import { Form, Formik, useFormikContext } from "formik";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { ReactComponent as RightArrow } from "../../../assets/icons/right-arrow.svg";
import Button from "../../../components/Button";
import FormField from "../../../components/FormField";
import { ShowToast } from "../../../components/toast";
import { api } from "../../../helpers/api";
import { setToken, setUser } from "../../../helpers/utils";
import { AutumnInfo } from "../components/AutumnInfo";
import { Layout } from "../components/Layout";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    // .matches(/^[^\s+@]+@[^\s@]+\.[^\s@]+$/, "Invalid email address")
    .email("Invalid email")
    .required("Email is required"),
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password is too short")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$/g,
      "Password must contain at least one uppercase and at least one lowercase letter and at least one special character",
    ),
});

const LoginForm = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("token") && localStorage.getItem("user")) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <Layout>
      <div className="flex w-full items-center">
        <div className="hidden lg:flex justify-center flex-1">
          <AutumnInfo />
        </div>
        <div className="flex-1">
          <Formik
            initialValues={{ email: "", password: "" }}
            isInitialValid={false}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              api
                .login({
                  ...values,
                  userType: "A",
                })
                .then(async (res) => {
                  localStorage.setItem("token", res.data.accessToken);
                  setToken(res.data?.accessToken);
                  if (res.data?.id) {
                    const userResponse = await api.getUserProfile(res.data?.id);
                    setUser({ ...res.data, ...userResponse });
                    actions.setSubmitting(false);
                    api.setActiveStatus(res.data?.id);

                    navigate("/dashboard");
                  } else {
                    actions.setSubmitting(false);
                  }
                })
                .catch((err) => {
                  actions.setSubmitting(false);

                  ShowToast({
                    message:
                      err.response.data.message || "Invalid email or password",
                    type: "error",
                  });
                });
            }}
          >
            <LoginFormContent />
          </Formik>
        </div>
      </div>
    </Layout>
  );
};

const LoginFormContent = () => {
  const { isValid, isSubmitting } = useFormikContext();

  return (
    <div className="grid items-center h-full justify-center">
      <div className="grid">
        <Form className="flex lg:min-w-[372px] w-[calc(100vw-2rem)] lg:w-auto flex-col gap-6 mb-[1.5rem]">
          <h1 className="text-content-primary text-[28px] font-bold tracking-[-1.12px] leading-[100%]">
            Sign in
          </h1>
          <div className="grid gap-4">
            <FormField
              label="Email"
              name="email"
              type="email"
              placeholder="Enter your email"
            />
            <FormField
              label="Password"
              name="password"
              type="password"
              placeholder="Enter your password"
            />
          </div>
          <div className="flex items-center justify-between gap-2">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                className="w-4 h-4 rounded border-border-primary"
              />
              <span className="text-sm text-content-primary">
                Stay signed in
              </span>
            </label>
            <Link
              to="/forgot-password"
              className="text-primary hover:text-primary-hover text-[13px] font-medium tracking-[-0.13px]"
            >
              Forgot password?
            </Link>
          </div>
          <div className="grid gap-4">
            <Button
              className=" bg-primary text-white hover:bg-white hover:text-primary hover:border hover:border-primary
    hover:opacity-70 w-full disabled:!bg-gray-300 disabled:!text-white"
              type="submit"
              disabled={!isValid}
              loading={isSubmitting}
            >
              Sign in <RightArrow />
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default LoginForm;
